var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#918F8F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5919_101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6831 14.4941L8.0805 14.4941L8.21443 16.3442C8.23192 16.5857 7.9524 16.7314 7.76445 16.5786L4.10211 13.603C3.96596 13.4924 3.96596 13.2846 4.10211 13.1739L7.76445 10.1983C7.9524 10.0456 8.23192 10.1912 8.21443 10.4328L8.08049 12.2829L12.5449 12.2829C13.2319 12.2829 13.7887 11.726 13.7887 11.039V8.14715C13.7887 7.4602 13.2319 6.90332 12.5449 6.90332L7.62076 6.90332C6.93381 6.90332 6.37693 7.4602 6.37693 8.14715V8.56476C6.37693 8.73715 6.29651 8.89967 6.15947 9.00425L5.05384 9.84791C4.69 10.1255 4.16567 9.86609 4.16567 9.40843L4.16567 8.00895C4.16567 6.17708 5.65069 4.69206 7.48256 4.69206L12.6831 4.69206C14.515 4.69206 16 6.17708 16 8.00895V11.1772C16 13.0091 14.515 14.4941 12.6831 14.4941Z",
    fill: "url(#paint0_linear_5919_101)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5919_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.33333,
    width: 16,
    height: 16,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5919_101",
    x1: 8.4463,
    y1: 9.47172,
    x2: 14.3741,
    y2: 16.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepayment);
export default __webpack_public_path__ + "static/media/Repayment.98d49f2bf46df4555e032670895eeaf0.svg";
export { ForwardRef as ReactComponent };